import { Link } from "react-router-dom";
import Slide from "react-reveal/Slide";

export const ServiceORMCard = () => {
  return (
    <>
      <Slide up>
        <p className="w3-center">
          <img
            width="70%"
            src={`${process.env.PUBLIC_URL + "/images/services/orm.jpg"}`}
            alt="service_image"
          />
        </p>
      </Slide>
      <Slide left>
        <p className="fontJostRegular w3-medium mt-4">
          Our Online Reputation Management service offers discreet and rapid
          solutions to safeguard your digital presence. We specialize in the
          strategic deletions and removals of unwanted content, ensuring your
          online image remains pristine and corporate.
        </p>
        <p className="fontJostRegular w3-medium mt-4">
          At ClearWater, we understand that your online reputation is a critical
          asset in today's digital landscape. It's not about hiding information;
          it's about ensuring that your digital footprint accurately reflects
          your brand's values, achievements, and professional standards.
        </p>
        <p className="fontJostRegular w3-medium mt-4">
          Our Online Reputation Management service is powered by sophisticated
          monitoring tools and expert intervention strategies. We continuously
          scan the web for mentions of your brand, analyze sentiment patterns,
          and identify potential reputation threats before they escalate into
          crises.
        </p>
        <p className="fontJostRegular w3-medium mt-4">
          Through strategic content management and targeted digital
          interventions, we'll help you maintain control over your online
          narrative. We utilize a comprehensive approach, addressing issues
          across search engines, social media platforms, review sites, and other
          digital channels to ensure a consistent and positive brand image.
        </p>
        <p className="fontJostRegular w3-medium mt-4">
          But effective reputation management isn't just about removing negative
          content; it's about building a robust digital presence that withstands
          scrutiny. Our team of specialists will work closely with you to
          develop a proactive reputation strategy, creating and promoting
          positive content that showcases your strengths and drowns out any
          negative noise.
        </p>
        <p className="fontJostRegular w3-medium mt-4">
          <br /> <br />
          <span className="text-3xl">
            Our Online Reputation Management services include:
          </span>
          <br /> <br />
          <ul>
            <li className="bg-blue-200 p-4 rounded text-gray-950 mb-2">
              24/7 Brand Monitoring & Alert Systems
            </li>
            <li className="bg-blue-200 p-4 rounded text-gray-950 mb-2">
              Strategic Content Removal & Suppression
            </li>
            <li className="bg-blue-200 p-4 rounded text-gray-950 mb-2">
              Positive Content Creation & Promotion
            </li>
            <li className="bg-blue-200 p-4 rounded text-gray-950 mb-2">
              Crisis Management & Rapid Response
            </li>
          </ul>
        </p>
        <p className="fontJostRegular w3-medium mt-4">
          With ClearWater as your partner, you'll benefit from our discreet
          approach, technical expertise, and proven track record of protecting
          and enhancing our clients' digital reputations.
        </p>

        {/* Call to Action Section */}
        <p
          className="bg-sky-950 text-white callToAction w3-round-large w3-center"
          style={{ marginTop: "50px" }}
        >
          <p className="w3-large fontJostBold w3-padding">
            Don't let negative content define your digital identity. Contact us
            today and let our Online Reputation Management service protect and
            enhance your online presence, ensuring your brand projects the
            professional image it deserves.
          </p>{" "}
          <br />
          <Link
            className="btn bg-white px-8 py-5 font-semibold rounded-3xl shadow-lg text-sky-950 mt-8 mb-4"
            to={"/contact"}
          >
            <span> Get a Quote</span>
          </Link>
        </p>
      </Slide>
    </>
  );
};

export default ServiceORMCard;
